export default {"src":"/_next/static/media/teacher-only.30a00fb3.svg","height":19,"width":25,"blurWidth":0,"blurHeight":0};